var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"width":"100%","height":"100%"}},[_c('video',{ref:"video",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.id,"controls":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }